import * as $ from 'jquery';

export const init = () => {
    $('.hamburger-menu').on('click',function(){
        $('.header-navigation').toggleClass('open');
        $('html').toggleClass('overflow-y');
    });
};